import icon1 from "../../assets/track_icons/icon1.webp";
import icon2 from "../../assets/track_icons/icon2.webp";
import icon3 from "../../assets/track_icons/icon3.webp";
import icon4 from "../../assets/track_icons/icon4.webp";
import icon5 from "../../assets/track_icons/icon5.webp";
import icon6 from "../../assets/track_icons/icon6.webp";
import icon7 from "../../assets/track_icons/icon7.webp";
import icon8 from "../../assets/track_icons/icon8.webp";
import icon9 from "../../assets/track_icons/icon9.webp";
import icon10 from "../../assets/track_icons/icon10.webp";
import icon11 from "../../assets/track_icons/icon11.webp";
import icon12 from "../../assets/track_icons/icon12.webp";
import icon13 from "../../assets/track_icons/icon13.webp";
import icon14 from "../../assets/track_icons/icon14.webp";
import icon15 from "../../assets/track_icons/icon15.webp";
import icon16 from "../../assets/track_icons/icon16.webp";
import icon17 from "../../assets/track_icons/icon17.webp";
import icon18 from "../../assets/track_icons/icon18.webp";
import icon19 from "../../assets/track_icons/icon19.webp";
import icon20 from "../../assets/track_icons/icon20.webp";
export const tracks = [
  { name:"Food Processing Technologies (HPP, PEF, Ultrasound, Ohmic)", icon: icon1  },
  { name: "Food Engineering", icon:  icon2},
  { name: "Thermal & Non-Thermal Preservation Methods", icon:  icon3 },
  { name: "Food Biotechnology - Enzymes & Fermentation", icon: icon4 },
  { name: "Probiotics & Functional Foods Innovation", icon:   icon5},
  { name: "Alternative Proteins: Plant-Based, Cultured & Fermentation-Derived", icon :icon6 },
  { name: "Nutraceuticals & Bioactive Compounds", icon:  icon7 },
  { name: "Food Safety Management", icon:icon8 },
  { name: "Food Quality Assurance & Shelf-Life Modeling", icon:icon9},
  { name: "Standards & Global Regulatory Compliance (FSSAI, FDA, EFSA)", icon:icon10},
  { name: "Food Fraud Detection & Analytical Technologies", icon:icon11 },
  { name: "Food Processing & Green Technologies", icon: icon12 },
  { name: "Plant–Microbiome Engineering", icon:icon13 },
  { name: "Smart, Biodegradable & Edible Packaging", icon: icon14},
  { name: "Climate-Smart Food Systems & Life Cycle Assessment (LCA)", icon:icon15 },
  { name: "IoT, Automation & Smart Manufacturing", icon:icon16 },
  { name: "Data Analytics for Food Innovation", icon: icon17 },
  { name: "Digital Twins, Predictive Modeling in Food Processing", icon: icon18 },
   { name: "Precision Fermentation", icon: icon19 },
  { name: "Cold Plasma Preservation", icon: icon20 },
  // { name: "Food Sciences", icon: icon20 },
];
